export { default } from "./primary-title"
